import { FC, ReactNode } from 'react';
import styles from './styles.module.css';

interface EmptyElementProps {
    title?: string;
    msg?: string;
    children?: ReactNode;
}

const EmptyElement: FC<EmptyElementProps> = ({ title, msg, children }) => {
    return (
        <div className={styles.wrapper}>
            {title && <h4>{title}</h4>}
            {msg && <p>{msg}</p>}
            {children}
        </div>
    );
};

export default EmptyElement;
